import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { NgxSelectModule } from 'ngx-select-ex';
import {SocialMediaContentDefinitionComponent} from './social-media-content-definition.component';
import {MaterialChipsInputModule} from '../project/tags/materialChipsInput.module';
import {TranslatePipeModule} from '../translate/translate.pipe.module';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    NgxSelectModule,
    NgxSelectModule,
    MaterialChipsInputModule,
    TranslatePipeModule
  ],
  declarations: [SocialMediaContentDefinitionComponent],
  providers: [],
  exports: [SocialMediaContentDefinitionComponent]
})

export class SocialMedialContentDefinitionModule {

}
